import { createSelector } from '@td/utils';

const getSurgeIncentiveIds = state => state.providerSurgeIncentive.incentives.allIds;
const getSurgeIncentivesById = state => state.providerSurgeIncentive.incentives.byId;

export default createSelector(
  getSurgeIncentiveIds,
  getSurgeIncentivesById,
  (surgeIncentiveIds, surgeIncentivesById) => surgeIncentiveIds.map(id => surgeIncentivesById[id])
);
